export default "__VITE_PUBLIC_ASSET__b4cb0d74__"